// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0

package io.github.suqi8.coui.kmp.icon.extended

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathNode
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.icon.COUIIcons

val COUIIcons.Delete: ImageVector
    get() = COUIIcons.Regular.Delete

val COUIIcons.Light.Delete: ImageVector
    get() {
        if (_deleteLight != null) return _deleteLight!!
        _deleteLight = ImageVector.Builder(
            name = "Delete.Light",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1246.8f,
            viewportHeight = 1246.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1246.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(878.9f, 116.9f),
                        PathNode.QuadTo(917.9f, 134.9f, 934.9f, 168.9f),
                        PathNode.QuadTo(944.9f, 186.9f, 949.4f, 213.9f),
                        PathNode.QuadTo(953.9f, 240.9f, 957.9f, 302.9f),
                        PathNode.LineTo(1001.9f, 908.9f),
                        PathNode.HorizontalTo(1081.9f),
                        PathNode.QuadTo(1088.9f, 908.9f, 1093.9f, 914.4f),
                        PathNode.QuadTo(1098.9f, 919.9f, 1098.9f, 927.9f),
                        PathNode.VerticalTo(948.9f),
                        PathNode.QuadTo(1098.9f, 956.9f, 1093.9f, 962.4f),
                        PathNode.QuadTo(1088.9f, 967.9f, 1081.9f, 967.9f),
                        PathNode.HorizontalTo(892.9f),
                        PathNode.QuadTo(871.9f, 967.9f, 862.9f, 973.4f),
                        PathNode.QuadTo(853.9f, 978.9f, 843.9f, 999.9f),
                        PathNode.LineTo(818.9f, 1053.9f),
                        PathNode.LineTo(813.9f, 1063.9f),
                        PathNode.QuadTo(805.9f, 1082.9f, 798.9f, 1095.4f),
                        PathNode.QuadTo(791.9f, 1107.9f, 784.9f, 1115.9f),
                        PathNode.QuadTo(770.9f, 1130.9f, 750.9f, 1137.9f),
                        PathNode.QuadTo(739.9f, 1140.9f, 722.4f, 1141.9f),
                        PathNode.QuadTo(704.9f, 1142.9f, 679.9f, 1142.9f),
                        PathNode.HorizontalTo(566.9f),
                        PathNode.QuadTo(541.9f, 1142.9f, 524.4f, 1141.9f),
                        PathNode.QuadTo(506.9f, 1140.9f, 496.9f, 1137.9f),
                        PathNode.QuadTo(479.9f, 1131.9f, 461.9f, 1115.9f),
                        PathNode.QuadTo(454.9f, 1107.9f, 446.9f, 1092.4f),
                        PathNode.QuadTo(438.9f, 1076.9f, 427.9f, 1053.9f),
                        PathNode.LineTo(399.9f, 994.9f),
                        PathNode.QuadTo(391.9f, 976.9f, 383.9f, 972.4f),
                        PathNode.QuadTo(375.9f, 967.9f, 352.9f, 967.9f),
                        PathNode.HorizontalTo(165.9f),
                        PathNode.QuadTo(158.9f, 967.9f, 153.4f, 962.4f),
                        PathNode.QuadTo(147.9f, 956.9f, 147.9f, 946.9f),
                        PathNode.VerticalTo(928.9f),
                        PathNode.QuadTo(147.9f, 918.9f, 153.4f, 913.9f),
                        PathNode.QuadTo(158.9f, 908.9f, 165.9f, 908.9f),
                        PathNode.HorizontalTo(235.9f),
                        PathNode.LineTo(277.9f, 303.9f),
                        PathNode.QuadTo(281.9f, 243.9f, 286.4f, 215.9f),
                        PathNode.QuadTo(290.9f, 187.9f, 300.9f, 168.9f),
                        PathNode.QuadTo(322.9f, 132.9f, 355.9f, 117.9f),
                        PathNode.QuadTo(374.9f, 108.9f, 402.9f, 106.4f),
                        PathNode.QuadTo(430.9f, 103.9f, 492.9f, 103.9f),
                        PathNode.HorizontalTo(743.9f),
                        PathNode.QuadTo(805.9f, 103.9f, 832.9f, 106.4f),
                        PathNode.QuadTo(859.9f, 108.9f, 878.9f, 116.9f),
                        PathNode.Close,
                        PathNode.MoveTo(387.9f, 171.9f),
                        PathNode.QuadTo(360.9f, 183.9f, 351.9f, 205.9f),
                        PathNode.QuadTo(345.9f, 216.9f, 343.9f, 231.4f),
                        PathNode.QuadTo(341.9f, 245.9f, 338.9f, 282.9f),
                        PathNode.LineTo(294.9f, 908.9f),
                        PathNode.HorizontalTo(942.9f),
                        PathNode.LineTo(898.9f, 282.9f),
                        PathNode.QuadTo(895.9f, 245.9f, 893.9f, 231.4f),
                        PathNode.QuadTo(891.9f, 216.9f, 885.9f, 205.9f),
                        PathNode.QuadTo(875.9f, 183.9f, 849.9f, 171.9f),
                        PathNode.QuadTo(836.9f, 166.9f, 820.9f, 165.4f),
                        PathNode.QuadTo(804.9f, 163.9f, 771.9f, 163.9f),
                        PathNode.HorizontalTo(465.9f),
                        PathNode.QuadTo(431.9f, 163.9f, 416.4f, 165.4f),
                        PathNode.QuadTo(400.9f, 166.9f, 387.9f, 171.9f),
                        PathNode.Close,
                        PathNode.MoveTo(556.9f, 338.9f),
                        PathNode.LineTo(540.9f, 759.9f),
                        PathNode.QuadTo(539.9f, 767.9f, 534.9f, 772.9f),
                        PathNode.QuadTo(529.9f, 777.9f, 522.9f, 777.9f),
                        PathNode.HorizontalTo(498.9f),
                        PathNode.QuadTo(491.9f, 777.9f, 486.4f, 772.9f),
                        PathNode.QuadTo(480.9f, 767.9f, 480.9f, 759.9f),
                        PathNode.LineTo(497.9f, 337.9f),
                        PathNode.QuadTo(498.9f, 329.9f, 503.9f, 324.9f),
                        PathNode.QuadTo(508.9f, 319.9f, 515.9f, 319.9f),
                        PathNode.HorizontalTo(538.9f),
                        PathNode.QuadTo(545.9f, 319.9f, 551.4f, 325.4f),
                        PathNode.QuadTo(556.9f, 330.9f, 556.9f, 338.9f),
                        PathNode.Close,
                        PathNode.MoveTo(739.9f, 336.9f),
                        PathNode.LineTo(756.9f, 759.9f),
                        PathNode.QuadTo(756.9f, 767.9f, 751.9f, 772.9f),
                        PathNode.QuadTo(746.9f, 777.9f, 738.9f, 777.9f),
                        PathNode.HorizontalTo(714.9f),
                        PathNode.QuadTo(707.9f, 777.9f, 702.9f, 772.9f),
                        PathNode.QuadTo(697.9f, 767.9f, 696.9f, 760.9f),
                        PathNode.LineTo(680.9f, 337.9f),
                        PathNode.QuadTo(680.9f, 329.9f, 686.4f, 324.4f),
                        PathNode.QuadTo(691.9f, 318.9f, 698.9f, 318.9f),
                        PathNode.HorizontalTo(721.9f),
                        PathNode.QuadTo(729.9f, 318.9f, 734.4f, 323.9f),
                        PathNode.QuadTo(738.9f, 328.9f, 739.9f, 336.9f),
                        PathNode.Close,
                        PathNode.MoveTo(457.9f, 977.9f),
                        PathNode.LineTo(492.9f, 1050.9f),
                        PathNode.QuadTo(501.9f, 1069.9f, 513.4f, 1076.4f),
                        PathNode.QuadTo(524.9f, 1082.9f, 545.9f, 1082.9f),
                        PathNode.HorizontalTo(700.9f),
                        PathNode.QuadTo(722.9f, 1082.9f, 733.9f, 1075.9f),
                        PathNode.QuadTo(744.9f, 1068.9f, 753.9f, 1050.9f),
                        PathNode.LineTo(788.9f, 979.9f),
                        PathNode.QuadTo(790.9f, 974.9f, 789.9f, 971.4f),
                        PathNode.QuadTo(788.9f, 967.9f, 783.9f, 967.9f),
                        PathNode.HorizontalTo(464.9f),
                        PathNode.QuadTo(458.9f, 967.9f, 457.4f, 970.4f),
                        PathNode.QuadTo(455.9f, 972.9f, 457.9f, 977.9f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _deleteLight!!
    }

private var _deleteLight: ImageVector? = null

val COUIIcons.Normal.Delete: ImageVector
    get() {
        if (_deleteNormal != null) return _deleteNormal!!
        _deleteNormal = ImageVector.Builder(
            name = "Delete.Normal",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1268.2f,
            viewportHeight = 1268.2f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1268.2f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(893.8f, 119.4f),
                        PathNode.QuadTo(934.1f, 138.1f, 953.9f, 174.8f),
                        PathNode.QuadTo(964.6f, 194.2f, 969.1f, 222.2f),
                        PathNode.QuadTo(973.6f, 250.2f, 977.6f, 312.9f),
                        PathNode.LineTo(1020.9f, 910.7f),
                        PathNode.HorizontalTo(1094.7f),
                        PathNode.QuadTo(1103.8f, 910.7f, 1110.8f, 917.9f),
                        PathNode.QuadTo(1117.9f, 925.1f, 1117.9f, 935.9f),
                        PathNode.VerticalTo(962.4f),
                        PathNode.QuadTo(1117.9f, 973.1f, 1110.8f, 980.3f),
                        PathNode.QuadTo(1103.8f, 987.6f, 1094.7f, 987.6f),
                        PathNode.HorizontalTo(912.6f),
                        PathNode.QuadTo(889.5f, 987.6f, 879.8f, 993.4f),
                        PathNode.QuadTo(870.1f, 999.2f, 860.8f, 1019.6f),
                        PathNode.LineTo(837.9f, 1068.8f),
                        PathNode.LineTo(831.5f, 1081.5f),
                        PathNode.QuadTo(823.5f, 1099.8f, 816.5f, 1112.3f),
                        PathNode.QuadTo(809.5f, 1124.8f, 801.8f, 1132.8f),
                        PathNode.QuadTo(785.1f, 1149.9f, 764.4f, 1156.9f),
                        PathNode.QuadTo(752.7f, 1160.6f, 734.5f, 1161.6f),
                        PathNode.QuadTo(716.3f, 1162.6f, 690.6f, 1162.6f),
                        PathNode.HorizontalTo(577.6f),
                        PathNode.QuadTo(552.6f, 1162.6f, 534.4f, 1161.6f),
                        PathNode.QuadTo(516.2f, 1160.6f, 504.9f, 1156.9f),
                        PathNode.QuadTo(484.4f, 1150.2f, 466.4f, 1132.8f),
                        PathNode.QuadTo(458.8f, 1124.1f, 450.1f, 1107.9f),
                        PathNode.QuadTo(441.4f, 1091.8f, 430.4f, 1068.8f),
                        PathNode.LineTo(404.4f, 1014.6f),
                        PathNode.QuadTo(396.4f, 996.6f, 388.1f, 992.1f),
                        PathNode.QuadTo(379.8f, 987.6f, 354.7f, 987.6f),
                        PathNode.HorizontalTo(175.2f),
                        PathNode.QuadTo(166.2f, 987.6f, 158.3f, 980.7f),
                        PathNode.QuadTo(150.4f, 973.8f, 150.4f, 959.7f),
                        PathNode.VerticalTo(937.6f),
                        PathNode.QuadTo(150.4f, 924.1f, 158.3f, 917.4f),
                        PathNode.QuadTo(166.2f, 910.7f, 175.2f, 910.7f),
                        PathNode.HorizontalTo(238.4f),
                        PathNode.LineTo(279.7f, 313.9f),
                        PathNode.QuadTo(283.7f, 251.2f, 288.2f, 222.8f),
                        PathNode.QuadTo(292.7f, 194.5f, 303.4f, 174.8f),
                        PathNode.QuadTo(326.8f, 136.8f, 363.2f, 119.7f),
                        PathNode.QuadTo(382.9f, 110.0f, 410.9f, 107.8f),
                        PathNode.QuadTo(438.9f, 105.7f, 503.6f, 105.7f),
                        PathNode.HorizontalTo(754.6f),
                        PathNode.QuadTo(819.4f, 105.7f, 846.7f, 107.8f),
                        PathNode.QuadTo(874.1f, 110.0f, 893.8f, 119.4f),
                        PathNode.Close,
                        PathNode.MoveTo(403.4f, 191.6f),
                        PathNode.QuadTo(381.2f, 201.5f, 370.9f, 222.1f),
                        PathNode.QuadTo(365.6f, 231.8f, 363.2f, 248.7f),
                        PathNode.QuadTo(360.9f, 265.6f, 358.6f, 294.3f),
                        PathNode.LineTo(315.2f, 910.7f),
                        PathNode.HorizontalTo(944.0f),
                        PathNode.LineTo(900.7f, 294.3f),
                        PathNode.QuadTo(898.4f, 265.6f, 896.0f, 248.7f),
                        PathNode.QuadTo(893.7f, 231.8f, 888.4f, 222.1f),
                        PathNode.QuadTo(877.7f, 201.5f, 855.8f, 191.6f),
                        PathNode.QuadTo(844.9f, 186.6f, 830.2f, 185.4f),
                        PathNode.QuadTo(815.6f, 184.2f, 782.6f, 184.2f),
                        PathNode.HorizontalTo(476.6f),
                        PathNode.QuadTo(443.3f, 184.2f, 428.8f, 185.4f),
                        PathNode.QuadTo(414.4f, 186.6f, 403.4f, 191.6f),
                        PathNode.Close,
                        PathNode.MoveTo(576.6f, 351.7f),
                        PathNode.LineTo(560.6f, 769.2f),
                        PathNode.QuadTo(559.6f, 778.6f, 552.8f, 785.3f),
                        PathNode.QuadTo(546.1f, 792.1f, 536.4f, 792.1f),
                        PathNode.HorizontalTo(506.9f),
                        PathNode.QuadTo(497.1f, 792.1f, 489.9f, 785.0f),
                        PathNode.QuadTo(482.7f, 777.9f, 482.7f, 767.9f),
                        PathNode.LineTo(499.7f, 350.0f),
                        PathNode.QuadTo(500.7f, 339.9f, 507.4f, 333.2f),
                        PathNode.QuadTo(514.1f, 326.5f, 523.9f, 326.5f),
                        PathNode.HorizontalTo(553.1f),
                        PathNode.QuadTo(562.8f, 326.5f, 570.0f, 334.1f),
                        PathNode.QuadTo(577.2f, 341.6f, 576.6f, 351.7f),
                        PathNode.Close,
                        PathNode.MoveTo(759.6f, 349.7f),
                        PathNode.LineTo(776.6f, 767.9f),
                        PathNode.QuadTo(776.6f, 777.9f, 769.5f, 785.0f),
                        PathNode.QuadTo(762.4f, 792.1f, 752.4f, 792.1f),
                        PathNode.HorizontalTo(722.9f),
                        PathNode.QuadTo(713.1f, 792.1f, 706.4f, 785.3f),
                        PathNode.QuadTo(699.7f, 778.6f, 698.7f, 769.6f),
                        PathNode.LineTo(682.7f, 351.4f),
                        PathNode.QuadTo(682.0f, 341.3f, 689.2f, 333.8f),
                        PathNode.QuadTo(696.4f, 326.2f, 706.2f, 326.2f),
                        PathNode.HorizontalTo(735.4f),
                        PathNode.QuadTo(745.4f, 326.2f, 752.0f, 332.9f),
                        PathNode.QuadTo(758.6f, 339.6f, 759.6f, 349.7f),
                        PathNode.Close,
                        PathNode.MoveTo(482.4f, 996.9f),
                        PathNode.LineTo(508.4f, 1050.6f),
                        PathNode.QuadTo(518.1f, 1071.7f, 530.3f, 1078.2f),
                        PathNode.QuadTo(542.5f, 1084.7f, 566.9f, 1084.7f),
                        PathNode.HorizontalTo(701.3f),
                        PathNode.QuadTo(726.8f, 1084.7f, 738.1f, 1078.0f),
                        PathNode.QuadTo(749.4f, 1071.4f, 759.1f, 1052.0f),
                        PathNode.LineTo(786.6f, 997.5f),
                        PathNode.QuadTo(788.6f, 993.9f, 787.2f, 990.7f),
                        PathNode.QuadTo(785.9f, 987.6f, 781.6f, 987.6f),
                        PathNode.HorizontalTo(488.0f),
                        PathNode.QuadTo(482.7f, 987.6f, 481.5f, 990.1f),
                        PathNode.QuadTo(480.4f, 992.6f, 482.4f, 996.9f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _deleteNormal!!
    }

private var _deleteNormal: ImageVector? = null

val COUIIcons.Regular.Delete: ImageVector
    get() {
        if (_deleteRegular != null) return _deleteRegular!!
        _deleteRegular = ImageVector.Builder(
            name = "Delete.Regular",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1278.0f,
            viewportHeight = 1278.0f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1278.0f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(900.5f, 120.5f),
                        PathNode.QuadTo(941.5f, 139.5f, 962.5f, 177.5f),
                        PathNode.QuadTo(973.5f, 197.5f, 978.0f, 226.0f),
                        PathNode.QuadTo(982.5f, 254.5f, 986.5f, 317.5f),
                        PathNode.LineTo(1029.5f, 911.5f),
                        PathNode.HorizontalTo(1100.5f),
                        PathNode.QuadTo(1110.5f, 911.5f, 1118.5f, 919.5f),
                        PathNode.QuadTo(1126.5f, 927.5f, 1126.5f, 939.5f),
                        PathNode.VerticalTo(968.5f),
                        PathNode.QuadTo(1126.5f, 980.5f, 1118.5f, 988.5f),
                        PathNode.QuadTo(1110.5f, 996.5f, 1100.5f, 996.5f),
                        PathNode.HorizontalTo(921.5f),
                        PathNode.QuadTo(897.5f, 996.5f, 887.5f, 1002.5f),
                        PathNode.QuadTo(877.5f, 1008.5f, 868.5f, 1028.5f),
                        PathNode.LineTo(846.5f, 1075.5f),
                        PathNode.LineTo(839.5f, 1089.5f),
                        PathNode.QuadTo(831.5f, 1107.5f, 824.5f, 1120.0f),
                        PathNode.QuadTo(817.5f, 1132.5f, 809.5f, 1140.5f),
                        PathNode.QuadTo(791.5f, 1158.5f, 770.5f, 1165.5f),
                        PathNode.QuadTo(758.5f, 1169.5f, 740.0f, 1170.5f),
                        PathNode.QuadTo(721.5f, 1171.5f, 695.5f, 1171.5f),
                        PathNode.HorizontalTo(582.5f),
                        PathNode.QuadTo(557.5f, 1171.5f, 539.0f, 1170.5f),
                        PathNode.QuadTo(520.5f, 1169.5f, 508.5f, 1165.5f),
                        PathNode.QuadTo(486.5f, 1158.5f, 468.5f, 1140.5f),
                        PathNode.QuadTo(460.5f, 1131.5f, 451.5f, 1115.0f),
                        PathNode.QuadTo(442.5f, 1098.5f, 431.5f, 1075.5f),
                        PathNode.LineTo(406.5f, 1023.5f),
                        PathNode.QuadTo(398.5f, 1005.5f, 390.0f, 1001.0f),
                        PathNode.QuadTo(381.5f, 996.5f, 355.5f, 996.5f),
                        PathNode.HorizontalTo(179.5f),
                        PathNode.QuadTo(169.5f, 996.5f, 160.5f, 989.0f),
                        PathNode.QuadTo(151.5f, 981.5f, 151.5f, 965.5f),
                        PathNode.VerticalTo(941.5f),
                        PathNode.QuadTo(151.5f, 926.5f, 160.5f, 919.0f),
                        PathNode.QuadTo(169.5f, 911.5f, 179.5f, 911.5f),
                        PathNode.HorizontalTo(239.5f),
                        PathNode.LineTo(280.5f, 318.5f),
                        PathNode.QuadTo(284.5f, 254.5f, 289.0f, 226.0f),
                        PathNode.QuadTo(293.5f, 197.5f, 304.5f, 177.5f),
                        PathNode.QuadTo(328.5f, 138.5f, 366.5f, 120.5f),
                        PathNode.QuadTo(386.5f, 110.5f, 414.5f, 108.5f),
                        PathNode.QuadTo(442.5f, 106.5f, 508.5f, 106.5f),
                        PathNode.HorizontalTo(759.5f),
                        PathNode.QuadTo(825.5f, 106.5f, 853.0f, 108.5f),
                        PathNode.QuadTo(880.5f, 110.5f, 900.5f, 120.5f),
                        PathNode.Close,
                        PathNode.MoveTo(410.5f, 200.5f),
                        PathNode.QuadTo(390.5f, 209.5f, 379.5f, 229.5f),
                        PathNode.QuadTo(374.5f, 238.5f, 372.0f, 256.5f),
                        PathNode.QuadTo(369.5f, 274.5f, 367.5f, 299.5f),
                        PathNode.LineTo(324.5f, 911.5f),
                        PathNode.HorizontalTo(944.5f),
                        PathNode.LineTo(901.5f, 299.5f),
                        PathNode.QuadTo(899.5f, 274.5f, 897.0f, 256.5f),
                        PathNode.QuadTo(894.5f, 238.5f, 889.5f, 229.5f),
                        PathNode.QuadTo(878.5f, 209.5f, 858.5f, 200.5f),
                        PathNode.QuadTo(848.5f, 195.5f, 834.5f, 194.5f),
                        PathNode.QuadTo(820.5f, 193.5f, 787.5f, 193.5f),
                        PathNode.HorizontalTo(481.5f),
                        PathNode.QuadTo(448.5f, 193.5f, 434.5f, 194.5f),
                        PathNode.QuadTo(420.5f, 195.5f, 410.5f, 200.5f),
                        PathNode.Close,
                        PathNode.MoveTo(585.5f, 357.5f),
                        PathNode.LineTo(569.5f, 773.5f),
                        PathNode.QuadTo(568.5f, 783.5f, 561.0f, 791.0f),
                        PathNode.QuadTo(553.5f, 798.5f, 542.5f, 798.5f),
                        PathNode.HorizontalTo(510.5f),
                        PathNode.QuadTo(499.5f, 798.5f, 491.5f, 790.5f),
                        PathNode.QuadTo(483.5f, 782.5f, 483.5f, 771.5f),
                        PathNode.LineTo(500.5f, 355.5f),
                        PathNode.QuadTo(501.5f, 344.5f, 509.0f, 337.0f),
                        PathNode.QuadTo(516.5f, 329.5f, 527.5f, 329.5f),
                        PathNode.HorizontalTo(559.5f),
                        PathNode.QuadTo(570.5f, 329.5f, 578.5f, 338.0f),
                        PathNode.QuadTo(586.5f, 346.5f, 585.5f, 357.5f),
                        PathNode.Close,
                        PathNode.MoveTo(768.5f, 355.5f),
                        PathNode.LineTo(785.5f, 771.5f),
                        PathNode.QuadTo(785.5f, 782.5f, 777.5f, 790.5f),
                        PathNode.QuadTo(769.5f, 798.5f, 758.5f, 798.5f),
                        PathNode.HorizontalTo(726.5f),
                        PathNode.QuadTo(715.5f, 798.5f, 708.0f, 791.0f),
                        PathNode.QuadTo(700.5f, 783.5f, 699.5f, 773.5f),
                        PathNode.LineTo(683.5f, 357.5f),
                        PathNode.QuadTo(682.5f, 346.5f, 690.5f, 338.0f),
                        PathNode.QuadTo(698.5f, 329.5f, 709.5f, 329.5f),
                        PathNode.HorizontalTo(741.5f),
                        PathNode.QuadTo(752.5f, 329.5f, 760.0f, 337.0f),
                        PathNode.QuadTo(767.5f, 344.5f, 768.5f, 355.5f),
                        PathNode.Close,
                        PathNode.MoveTo(493.5f, 1005.5f),
                        PathNode.LineTo(515.5f, 1050.5f),
                        PathNode.QuadTo(525.5f, 1072.5f, 538.0f, 1079.0f),
                        PathNode.QuadTo(550.5f, 1085.5f, 576.5f, 1085.5f),
                        PathNode.HorizontalTo(701.5f),
                        PathNode.QuadTo(728.5f, 1085.5f, 740.0f, 1079.0f),
                        PathNode.QuadTo(751.5f, 1072.5f, 761.5f, 1052.5f),
                        PathNode.LineTo(785.5f, 1005.5f),
                        PathNode.QuadTo(787.5f, 1002.5f, 786.0f, 999.5f),
                        PathNode.QuadTo(784.5f, 996.5f, 780.5f, 996.5f),
                        PathNode.HorizontalTo(498.5f),
                        PathNode.QuadTo(493.5f, 996.5f, 492.5f, 999.0f),
                        PathNode.QuadTo(491.5f, 1001.5f, 493.5f, 1005.5f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _deleteRegular!!
    }

private var _deleteRegular: ImageVector? = null

val COUIIcons.Medium.Delete: ImageVector
    get() {
        if (_deleteMedium != null) return _deleteMedium!!
        _deleteMedium = ImageVector.Builder(
            name = "Delete.Medium",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1294.9f,
            viewportHeight = 1294.9f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1294.9f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(912.5f, 122.5f),
                        PathNode.QuadTo(955.3f, 142.7f, 977.4f, 182.4f),
                        PathNode.QuadTo(989.0f, 203.0f, 993.5f, 232.1f),
                        PathNode.QuadTo(998.0f, 261.2f, 1002.0f, 325.4f),
                        PathNode.LineTo(1044.4f, 912.9f),
                        PathNode.HorizontalTo(1109.0f),
                        PathNode.QuadTo(1122.5f, 912.9f, 1132.3f, 923.0f),
                        PathNode.QuadTo(1142.0f, 933.0f, 1142.0f, 948.0f),
                        PathNode.VerticalTo(977.0f),
                        PathNode.QuadTo(1142.0f, 991.9f, 1132.0f, 1002.0f),
                        PathNode.QuadTo(1121.9f, 1012.0f, 1109.0f, 1012.0f),
                        PathNode.HorizontalTo(930.0f),
                        PathNode.QuadTo(908.3f, 1012.0f, 900.1f, 1016.9f),
                        PathNode.QuadTo(891.9f, 1021.7f, 883.4f, 1039.9f),
                        PathNode.LineTo(861.4f, 1087.5f),
                        PathNode.LineTo(852.7f, 1105.0f),
                        PathNode.QuadTo(845.3f, 1121.3f, 838.3f, 1133.8f),
                        PathNode.QuadTo(831.3f, 1146.3f, 823.3f, 1154.3f),
                        PathNode.QuadTo(804.7f, 1172.9f, 781.3f, 1181.0f),
                        PathNode.QuadTo(768.7f, 1185.0f, 749.4f, 1186.0f),
                        PathNode.QuadTo(730.0f, 1187.0f, 704.0f, 1187.0f),
                        PathNode.HorizontalTo(591.0f),
                        PathNode.QuadTo(565.4f, 1187.0f, 546.3f, 1186.0f),
                        PathNode.QuadTo(527.2f, 1185.0f, 514.6f, 1181.0f),
                        PathNode.QuadTo(490.3f, 1172.9f, 471.7f, 1154.3f),
                        PathNode.QuadTo(463.1f, 1144.7f, 453.8f, 1127.6f),
                        PathNode.QuadTo(444.5f, 1110.5f, 433.5f, 1087.5f),
                        PathNode.LineTo(408.5f, 1034.9f),
                        PathNode.QuadTo(401.1f, 1019.3f, 394.1f, 1015.6f),
                        PathNode.QuadTo(387.0f, 1012.0f, 364.0f, 1012.0f),
                        PathNode.HorizontalTo(188.0f),
                        PathNode.QuadTo(175.0f, 1012.0f, 164.0f, 1002.5f),
                        PathNode.QuadTo(152.9f, 992.9f, 152.9f, 974.0f),
                        PathNode.VerticalTo(950.0f),
                        PathNode.QuadTo(152.9f, 932.0f, 164.0f, 922.5f),
                        PathNode.QuadTo(175.0f, 912.9f, 188.0f, 912.9f),
                        PathNode.HorizontalTo(241.5f),
                        PathNode.LineTo(281.9f, 326.4f),
                        PathNode.QuadTo(285.9f, 261.8f, 290.4f, 232.4f),
                        PathNode.QuadTo(294.9f, 203.0f, 306.5f, 182.4f),
                        PathNode.QuadTo(331.1f, 141.7f, 371.4f, 122.5f),
                        PathNode.QuadTo(392.6f, 112.5f, 421.8f, 110.2f),
                        PathNode.QuadTo(451.0f, 107.9f, 517.0f, 107.9f),
                        PathNode.HorizontalTo(768.0f),
                        PathNode.QuadTo(834.0f, 107.9f, 862.6f, 110.2f),
                        PathNode.QuadTo(891.3f, 112.5f, 912.5f, 122.5f),
                        PathNode.Close,
                        PathNode.MoveTo(421.9f, 215.4f),
                        PathNode.QuadTo(404.3f, 223.3f, 394.4f, 241.5f),
                        PathNode.QuadTo(389.4f, 249.9f, 387.2f, 267.0f),
                        PathNode.QuadTo(385.0f, 284.1f, 383.0f, 308.6f),
                        PathNode.LineTo(340.6f, 912.9f),
                        PathNode.HorizontalTo(945.3f),
                        PathNode.LineTo(902.9f, 313.9f),
                        PathNode.QuadTo(900.9f, 286.5f, 898.7f, 268.2f),
                        PathNode.QuadTo(896.5f, 249.9f, 891.5f, 241.5f),
                        PathNode.QuadTo(881.7f, 223.3f, 864.0f, 215.4f),
                        PathNode.QuadTo(854.6f, 211.0f, 839.1f, 210.0f),
                        PathNode.QuadTo(823.7f, 209.0f, 796.0f, 209.0f),
                        PathNode.HorizontalTo(490.0f),
                        PathNode.QuadTo(461.7f, 209.0f, 446.5f, 210.0f),
                        PathNode.QuadTo(431.3f, 211.0f, 421.9f, 215.4f),
                        PathNode.Close,
                        PathNode.MoveTo(599.9f, 367.7f),
                        PathNode.LineTo(584.4f, 780.2f),
                        PathNode.QuadTo(583.4f, 792.6f, 575.1f, 800.6f),
                        PathNode.QuadTo(566.7f, 808.7f, 553.9f, 808.7f),
                        PathNode.HorizontalTo(515.4f),
                        PathNode.QuadTo(502.1f, 808.7f, 493.2f, 800.1f),
                        PathNode.QuadTo(484.3f, 791.6f, 484.9f, 778.2f),
                        PathNode.LineTo(501.3f, 365.7f),
                        PathNode.QuadTo(502.3f, 352.4f, 510.4f, 344.3f),
                        PathNode.QuadTo(518.5f, 336.2f, 531.9f, 336.2f),
                        PathNode.HorizontalTo(569.7f),
                        PathNode.QuadTo(583.1f, 336.2f, 592.0f, 345.0f),
                        PathNode.QuadTo(600.9f, 353.8f, 599.9f, 367.7f),
                        PathNode.Close,
                        PathNode.MoveTo(784.6f, 365.7f),
                        PathNode.LineTo(801.0f, 778.2f),
                        PathNode.QuadTo(801.6f, 791.6f, 792.7f, 800.1f),
                        PathNode.QuadTo(783.9f, 808.7f, 770.5f, 808.7f),
                        PathNode.HorizontalTo(732.0f),
                        PathNode.QuadTo(719.3f, 808.7f, 710.9f, 800.6f),
                        PathNode.QuadTo(702.5f, 792.6f, 701.5f, 780.2f),
                        PathNode.LineTo(686.1f, 367.7f),
                        PathNode.QuadTo(685.1f, 353.8f, 694.0f, 345.0f),
                        PathNode.QuadTo(702.9f, 336.2f, 716.2f, 336.2f),
                        PathNode.HorizontalTo(754.1f),
                        PathNode.QuadTo(767.4f, 336.2f, 775.5f, 344.3f),
                        PathNode.QuadTo(783.6f, 352.4f, 784.6f, 365.7f),
                        PathNode.Close,
                        PathNode.MoveTo(513.1f, 1021.0f),
                        PathNode.LineTo(530.4f, 1056.0f),
                        PathNode.QuadTo(539.9f, 1075.7f, 550.6f, 1081.3f),
                        PathNode.QuadTo(561.3f, 1086.9f, 585.0f, 1086.9f),
                        PathNode.HorizontalTo(710.0f),
                        PathNode.QuadTo(734.6f, 1086.9f, 744.6f, 1081.3f),
                        PathNode.QuadTo(754.7f, 1075.7f, 763.5f, 1057.4f),
                        PathNode.LineTo(782.2f, 1020.4f),
                        PathNode.QuadTo(784.2f, 1017.4f, 782.7f, 1014.7f),
                        PathNode.QuadTo(781.2f, 1012.0f, 777.2f, 1012.0f),
                        PathNode.HorizontalTo(518.1f),
                        PathNode.QuadTo(513.7f, 1012.0f, 512.4f, 1014.5f),
                        PathNode.QuadTo(511.1f, 1017.0f, 513.1f, 1021.0f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _deleteMedium!!
    }

private var _deleteMedium: ImageVector? = null

val COUIIcons.Demibold.Delete: ImageVector
    get() {
        if (_deleteDemibold != null) return _deleteDemibold!!
        _deleteDemibold = ImageVector.Builder(
            name = "Delete.Demibold",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1306.8f,
            viewportHeight = 1306.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1306.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(920.9f, 123.9f),
                        PathNode.QuadTo(964.9f, 144.9f, 987.9f, 185.9f),
                        PathNode.QuadTo(999.9f, 206.9f, 1004.4f, 236.4f),
                        PathNode.QuadTo(1008.9f, 265.9f, 1012.9f, 330.9f),
                        PathNode.LineTo(1054.9f, 913.9f),
                        PathNode.HorizontalTo(1114.9f),
                        PathNode.QuadTo(1130.9f, 913.9f, 1141.9f, 925.4f),
                        PathNode.QuadTo(1152.9f, 936.9f, 1152.9f, 953.9f),
                        PathNode.VerticalTo(982.9f),
                        PathNode.QuadTo(1152.9f, 999.9f, 1141.4f, 1011.4f),
                        PathNode.QuadTo(1129.9f, 1022.9f, 1114.9f, 1022.9f),
                        PathNode.HorizontalTo(935.9f),
                        PathNode.QuadTo(915.9f, 1022.9f, 908.9f, 1026.9f),
                        PathNode.QuadTo(901.9f, 1030.9f, 893.9f, 1047.9f),
                        PathNode.LineTo(871.9f, 1095.9f),
                        PathNode.LineTo(861.9f, 1115.9f),
                        PathNode.QuadTo(854.9f, 1130.9f, 847.9f, 1143.4f),
                        PathNode.QuadTo(840.9f, 1155.9f, 832.9f, 1163.9f),
                        PathNode.QuadTo(813.9f, 1182.9f, 788.9f, 1191.9f),
                        PathNode.QuadTo(775.9f, 1195.9f, 755.9f, 1196.9f),
                        PathNode.QuadTo(735.9f, 1197.9f, 709.9f, 1197.9f),
                        PathNode.HorizontalTo(596.9f),
                        PathNode.QuadTo(570.9f, 1197.9f, 551.4f, 1196.9f),
                        PathNode.QuadTo(531.9f, 1195.9f, 518.9f, 1191.9f),
                        PathNode.QuadTo(492.9f, 1182.9f, 473.9f, 1163.9f),
                        PathNode.QuadTo(464.9f, 1153.9f, 455.4f, 1136.4f),
                        PathNode.QuadTo(445.9f, 1118.9f, 434.9f, 1095.9f),
                        PathNode.LineTo(409.9f, 1042.9f),
                        PathNode.QuadTo(402.9f, 1028.9f, 396.9f, 1025.9f),
                        PathNode.QuadTo(390.9f, 1022.9f, 369.9f, 1022.9f),
                        PathNode.HorizontalTo(193.9f),
                        PathNode.QuadTo(178.9f, 1022.9f, 166.4f, 1011.9f),
                        PathNode.QuadTo(153.9f, 1000.9f, 153.9f, 979.9f),
                        PathNode.VerticalTo(955.9f),
                        PathNode.QuadTo(153.9f, 935.9f, 166.4f, 924.9f),
                        PathNode.QuadTo(178.9f, 913.9f, 193.9f, 913.9f),
                        PathNode.HorizontalTo(242.9f),
                        PathNode.LineTo(282.9f, 331.9f),
                        PathNode.QuadTo(286.9f, 266.9f, 291.4f, 236.9f),
                        PathNode.QuadTo(295.9f, 206.9f, 307.9f, 185.9f),
                        PathNode.QuadTo(332.9f, 143.9f, 374.9f, 123.9f),
                        PathNode.QuadTo(396.9f, 113.9f, 426.9f, 111.4f),
                        PathNode.QuadTo(456.9f, 108.9f, 522.9f, 108.9f),
                        PathNode.HorizontalTo(773.9f),
                        PathNode.QuadTo(839.9f, 108.9f, 869.4f, 111.4f),
                        PathNode.QuadTo(898.9f, 113.9f, 920.9f, 123.9f),
                        PathNode.Close,
                        PathNode.MoveTo(429.9f, 225.9f),
                        PathNode.QuadTo(413.9f, 232.9f, 404.9f, 249.9f),
                        PathNode.QuadTo(399.9f, 257.9f, 397.9f, 274.4f),
                        PathNode.QuadTo(395.9f, 290.9f, 393.9f, 314.9f),
                        PathNode.LineTo(351.9f, 913.9f),
                        PathNode.HorizontalTo(945.9f),
                        PathNode.LineTo(903.9f, 323.9f),
                        PathNode.QuadTo(901.9f, 294.9f, 899.9f, 276.4f),
                        PathNode.QuadTo(897.9f, 257.9f, 892.9f, 249.9f),
                        PathNode.QuadTo(883.9f, 232.9f, 867.9f, 225.9f),
                        PathNode.QuadTo(858.9f, 221.9f, 842.4f, 220.9f),
                        PathNode.QuadTo(825.9f, 219.9f, 801.9f, 219.9f),
                        PathNode.HorizontalTo(495.9f),
                        PathNode.QuadTo(470.9f, 219.9f, 454.9f, 220.9f),
                        PathNode.QuadTo(438.9f, 221.9f, 429.9f, 225.9f),
                        PathNode.Close,
                        PathNode.MoveTo(609.9f, 374.9f),
                        PathNode.LineTo(594.9f, 784.9f),
                        PathNode.QuadTo(593.9f, 798.9f, 584.9f, 807.4f),
                        PathNode.QuadTo(575.9f, 815.9f, 561.9f, 815.9f),
                        PathNode.HorizontalTo(518.9f),
                        PathNode.QuadTo(503.9f, 815.9f, 494.4f, 806.9f),
                        PathNode.QuadTo(484.9f, 797.9f, 485.9f, 782.9f),
                        PathNode.LineTo(501.9f, 372.9f),
                        PathNode.QuadTo(502.9f, 357.9f, 511.4f, 349.4f),
                        PathNode.QuadTo(519.9f, 340.9f, 534.9f, 340.9f),
                        PathNode.HorizontalTo(576.9f),
                        PathNode.QuadTo(591.9f, 340.9f, 601.4f, 349.9f),
                        PathNode.QuadTo(610.9f, 358.9f, 609.9f, 374.9f),
                        PathNode.Close,
                        PathNode.MoveTo(795.9f, 372.9f),
                        PathNode.LineTo(811.9f, 782.9f),
                        PathNode.QuadTo(812.9f, 797.9f, 803.4f, 806.9f),
                        PathNode.QuadTo(793.9f, 815.9f, 778.9f, 815.9f),
                        PathNode.HorizontalTo(735.9f),
                        PathNode.QuadTo(721.9f, 815.9f, 712.9f, 807.4f),
                        PathNode.QuadTo(703.9f, 798.9f, 702.9f, 784.9f),
                        PathNode.LineTo(687.9f, 374.9f),
                        PathNode.QuadTo(686.9f, 358.9f, 696.4f, 349.9f),
                        PathNode.QuadTo(705.9f, 340.9f, 720.9f, 340.9f),
                        PathNode.HorizontalTo(762.9f),
                        PathNode.QuadTo(777.9f, 340.9f, 786.4f, 349.4f),
                        PathNode.QuadTo(794.9f, 357.9f, 795.9f, 372.9f),
                        PathNode.Close,
                        PathNode.MoveTo(526.9f, 1031.9f),
                        PathNode.LineTo(540.9f, 1059.9f),
                        PathNode.QuadTo(549.9f, 1077.9f, 559.4f, 1082.9f),
                        PathNode.QuadTo(568.9f, 1087.9f, 590.9f, 1087.9f),
                        PathNode.HorizontalTo(715.9f),
                        PathNode.QuadTo(738.9f, 1087.9f, 747.9f, 1082.9f),
                        PathNode.QuadTo(756.9f, 1077.9f, 764.9f, 1060.9f),
                        PathNode.LineTo(779.9f, 1030.9f),
                        PathNode.QuadTo(781.9f, 1027.9f, 780.4f, 1025.4f),
                        PathNode.QuadTo(778.9f, 1022.9f, 774.9f, 1022.9f),
                        PathNode.HorizontalTo(531.9f),
                        PathNode.QuadTo(527.9f, 1022.9f, 526.4f, 1025.4f),
                        PathNode.QuadTo(524.9f, 1027.9f, 526.9f, 1031.9f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _deleteDemibold!!
    }

private var _deleteDemibold: ImageVector? = null
